/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import * as React from 'react';
import { Router, Route } from 'react-router-dom';
import { AdresseZustandProvider } from '@mairistem/administres-utils';
import {
  EntiteZustandProvider,
  ProduitDomaineZustandProvider,
} from '../Zustand';

const Context = (p: any) => {
  const { children, path, history, scope } = p;

  return (
    <Router history={history}>
      <Route path={path}>
        {scope === 'content' ? (
          <AdresseZustandProvider>
            <ProduitDomaineZustandProvider>
              <EntiteZustandProvider>
                {React.isValidElement(children)
                  ? children
                  : React.createElement(children)}
              </EntiteZustandProvider>
            </ProduitDomaineZustandProvider>
          </AdresseZustandProvider>
        ) : React.isValidElement(children) ? (
          children
        ) : (
          React.createElement(children)
        )}
      </Route>
    </Router>
  );
};

export default Context;
